import React, { useContext, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { supabase } from '../../services/supabaseClient'
import Sidebar from './Admin/Sidebar'
import Header from './Admin/Header'
import { Toaster } from 'react-hot-toast'
import { AuthContext } from '../../context/AuthContext'
import useApi from '../../hooks/useApi'
import { getUserAvatar } from '../../api/supabaseApi'
import LoadingOverlay from '../common/LoadingOverlay'

const AdminLayout = () => {
  const {
    session: { user },
    role,
  } = useContext(AuthContext)

  const {
    data: avatar,
    loading,
    error,
  } = useApi(() => getUserAvatar(user.id), [user])
  const [isSidebarOpen, setIsSidebarOpen] = useState(false) // Sidebar starts open on desktop
  const [isProfileOpen, setisProfileOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true)
      } else {
        setIsSidebarOpen(false)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleClickOutside = (event) => {
    if (!event.target.closest('.avatar-menu')) {
      setisProfileOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const logoutUser = async () => {
    await supabase.auth.signOut()
  }

  const toggleProfile = () => {
    setisProfileOpen(!isProfileOpen)
  }

  return (
    <div className="h-screen bg-gray-100 block md:flex">
      <Toaster />
      {/* Sidebar */}
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content */}
      <div
        className={`flex-1 flex flex-col transition-all duration-300 ease-in-out transform`}
      >
        {/* Top bar */}
        <Header
          toggleProfile={toggleProfile}
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isProfileOpen={isProfileOpen}
          logoutUser={logoutUser}
          avatarUrl={avatar?.readyplayer_url}
        />

        {/* Main Content Area */}
        <main className="flex-1 p-6 bg-gray-50 overflow-auto z-0">
          <Outlet />
        </main>
      </div>

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black opacity-50 z-40 md:hidden"
        ></div>
      )}
    </div>
  )
}

export default AdminLayout
